import { memo, useEffect } from 'react';
import { subscribe, unsubscribe } from 'pubsub-js';
import classNames from 'classnames';
import { useAppointmentForm } from './useAppointmentForm';
import styles from './Forms.module.scss';
import { SubmitButton } from './SubmitButton';
import { RESET_FORMS_EVENT } from '../../utils/constants';
import { PatternFormat } from 'react-number-format';

export const TopForm = memo(({ onCreateContact, children }) => {
  const { formData, errors, isSubmitting, onInputChange, onFormSubmit, resetForm } = useAppointmentForm({
    onCreateContact
  });

  useEffect(() => {
    const token = subscribe(RESET_FORMS_EVENT, () => resetForm());

    return () => {
      unsubscribe(token);
    };
  }, []);

  return (
    <form onSubmit={onFormSubmit}>
      <div className={styles.formContainer}>
        <div className={styles.formColumn}>
          <input
            type="text"
            className={classNames(styles.formInput, { [styles.inputError]: errors.firstName })}
            placeholder="First Name"
            name="firstName"
            value={formData.firstName}
            onChange={onInputChange}
            aria-label="First Name"
            tabIndex={1}
          />
          <input
            type="text"
            className={classNames(styles.formInput, { [styles.inputError]: errors.email })}
            placeholder="Email"
            name="email"
            value={formData.email}
            onChange={onInputChange}
            formNoValidate={true}
            aria-label="Email"
            tabIndex={3}
          />
        </div>
        <div className={styles.formColumn}>
          <input
            type="text"
            className={classNames(styles.formInput, { [styles.inputError]: errors.lastName })}
            placeholder="Last Name"
            name="lastName"
            value={formData.lastName}
            onChange={onInputChange}
            aria-label="Last Name"
            tabIndex={2}
          />
          <PatternFormat
            aria-label="Phone"
            className={classNames(styles.formInput, { [styles.inputError]: errors.phone })}
            format="###-###-####"
            placeholder="Phone (###-###-####)"
            name="phone"
            value={formData.phone}
            onChange={onInputChange}
            tabIndex={4}
          />
        </div>
      </div>
      <div className={styles.ctaButtonContainer}>
        <SubmitButton isSubmitting={isSubmitting} />
      </div>
      {children}
    </form>
  );
});
